/**
 * Shared expert-review UI: ExpertRecommendation.tsx.
 *
 * Belongs here: reusable presentational piece.
 * Does not belong here: flow rules or API.
 */
import RenderHTML from '../../../../../components/ui-components/RenderHTML'

export const EXPERT_RECOMMENDATIONS_ICON = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
  <g style="mix-blend-mode:plus-darker">
    <path d="M2 15.5C4.82008 14.9683 8.24958 11.7561 8.17505 6.131C8.10053 0.505891 2.9372 0.881995 2.9372 5.70552C2.9372 10.6478 5.67936 15.5 9.09937 15.5C11.6361 15.5 12.4142 13.589 12.4142 11.8588C12.4142 13.618 13.2328 15.5 16.625 15.5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" stroke="#732E17"/>
  </g>
</svg>`

export interface ExpertRecommendationProps {
  displayText: string
  subText: string
}

export function ExpertRecommendation({ displayText, subText }: ExpertRecommendationProps) {
  const recommendationText = displayText?.trim() ?? ''
  const recommendationSubText = subText?.trim() ?? ''

  return (
    <div
      className="mt-6 flex w-full flex-col gap-[14px] overflow-hidden rounded-[16px] px-5 pb-6 pt-5"
      style={{ backgroundImage: 'linear-gradient(103deg, var(--Prime-Prime10, #FCF1ED) 50.14%, #F2DBD4 100%)' }}
    >
      <div className="flex items-center gap-4">
        <div className="h-[18px] w-[18px] shrink-0 overflow-hidden">
          <RenderHTML
            innerHTMLText={EXPERT_RECOMMENDATIONS_ICON}
            className="h-full w-full [&>svg]:block [&>svg]:h-full [&>svg]:w-full"
          />
        </div>
        <p className="min-w-0 flex-1 text-[14px] font-[500] leading-[130%] text-[#732E17]">
          Expert Recommendation
        </p>
      </div>
      {recommendationText || recommendationSubText ? (
        <div className="flex flex-col gap-2">
          {recommendationText ? (
            <p className="text-[13px] font-[400] leading-[140%] text-[#3D3D3D]">{recommendationText}</p>
          ) : null}
          {recommendationSubText ? (
            <p className="text-[13px] font-[400] leading-[140%] text-[#3D3D3D]">{recommendationSubText}</p>
          ) : null}
        </div>
      ) : null}
    </div>
  )
}
